module.exports = __webpack_public_path__ + "static/media/logo.179bcf65.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyLogo/logo.svg
// module id = 308
// module chunks = 0